var DateUnit;
(function (DateUnit) {
    DateUnit["Days"] = "days";
    DateUnit["Hours"] = "hours";
    DateUnit["Milliseconds"] = "milliseconds";
    DateUnit["Minutes"] = "minutes";
    DateUnit["Seconds"] = "seconds";
    DateUnit["Year"] = "year";
})(DateUnit || (DateUnit = {}));

export { DateUnit as D };
//# sourceMappingURL=unit-e9fb035f.js.map
